import { t } from 'i18next';
import { ERROR_CODE } from '../constants/errorCodes';

type TranslationParams = Record<string, string | number | undefined>;

export const tWithParams = (
  key: string,
  params: TranslationParams = {},
  options?: {
    translateKeys?: string[];
    ns?: string;
    paramsNs?: string;
    defaultValue?: string;
  }
) => {
  const { translateKeys = [], ns, paramsNs, defaultValue } = options || {};

  const translatedParams: TranslationParams = { ...params };

  for (const paramKey of translateKeys) {
    const value = params[paramKey];

    if (typeof value === 'string') {
      translatedParams[paramKey] = t(value, { ns: paramsNs || ns });
    }
  }

  const translationKey = ERROR_CODE[key] || key;

  return t(translationKey, { ...translatedParams, ns, defaultValue });
};

export const tError = (
  errorCode: string,
  params: TranslationParams = {},
  options?: {
    translateKeys?: string[];
  }
) => tWithParams(errorCode, params, { ...options, ns: 'errors' });
